import Vue from "vue"
import App from "./App.vue"
import Router from "vue-router"
import router from "@/router"
Vue.config.productionTip = false

import "@/styles/index.less"

// 修改路由跳转报错的bug-start
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
import { beforeEachHandler } from "@/router/before-each"
import afterEachHandler from "@/router/after-each"
router.beforeEach(beforeEachHandler)
router.afterEach(afterEachHandler)

import ElementUi from "element-ui"
//引入element的css
import "element-ui/lib/theme-chalk/index.css"
Vue.use(ElementUi)

import {getGlobalConfigApi} from "@/api/module/common-api.js"
import dictConfig from "@/dict-config.js"
import vue2ElementDict from "~/index"

// const vueElementDict = require("../lib/vue-element-dict.umd.min.js")

//获取当前版本号
getGlobalConfigApi().then(data => {
  const {version} = data
  Object.assign(dictConfig, {version})
  Vue.use(vue2ElementDict, dictConfig)
  console.log("🚀 ~ file: main.js ~ line 34 ~ getGlobalConfigApi ~ vueElementDict", vue2ElementDict)
  new Vue({
    router,
    render: h => h(App)
  }).$mount("#app")
})
